import React, { useState, useRef } from "react";
import { FaChevronDown } from "react-icons/fa";
import UseScrollAnimation from "../Elements/ScrollAnimation";
import { Link } from "react-router-dom";

// import ThreeTestimonials from "./Page_Sections/threeTestimonials";
// import AboutThePractitioner from "./Page_Sections/aboutThePractitioner";

const faqs = [
  {
    q: "What is classical homeopathy?",
    a: (
      <>
        Classical Homeopathy is the traditional method of homeopathic practice
        established by the founder, Dr. Samuel Hahnemann. It focuses on
        prescribing a single, individualized remedy at a time, based on the
        totality of a person’s symptoms and constitution, following the
        fundamental therapeutic law of homeopathy - "similia similibus
        curentur", a latin phrase that translates to "likes are cured by likes".{" "}
        <b>
          A single, carefully matched remedy is prescribed to support your
          body's natural healing capacity.
        </b>
      </>
    ),
  },
  {
    q: "How is a remedy chosen for me?",
    a: "During an initial 90-minute consultation, I take a detailed history covering your physical, mental, and emotional patterns. The remedy that most closely resonates with your unique picture is then recommended.",
  },
  {
    q: "How long does it take to see results?",
    a: "Acute issues often respond within hours or days. Chronic conditions usually unfold gradually over weeks to months, with steady follow-ups to refine the approach.",
  },
  {
    q: "Are remedies safe with my other remedies?",
    a: "Yes — homeopathic remedies are gentle and generally safe alongside conventional remedies. I always recommend keeping your doctor informed and never stopping prescriptions on your own.",
  },
  {
    q: "Do you heal children?",
    a: "Absolutely. Homeopathy is wonderfully suited to children — from newborns through adolescence — for everything from colic and teething to behavioral and immune support.",
  },
  {
    q: "Do you offer telehealth?",
    a: "Yes. Most consultations are conducted by secure video, which works beautifully for homeopathy and allows me to serve clients anywhere.",
  },
  {
    q: "What does it cost?",
    a: (
      <>
        Initial consultations and follow-ups are priced transparently.
        <br />
        <Link to="/services">More Details</Link>
      </>
    ),
  },
  {
    q: "Is homeopathy a replacement for conventional care?",
    a: "Homeopathy works wonderfully as part of an integrative approach. It is not a replacement for conventional care, emergency or critical care, and I always encourage continued partnership with your primary physician.",
  },
  {
    q: "Do you accept health insurance or HSA?",
    a: "Homeopathy in USA is generally not covered by standard health insurance plans, meaning you will need to pay for these services out-of-pocket. However, because they are legally recognized as qualified medical expenses, you can use your Health Savings Account (HSA) for the consultation services.",
  },
];

const FAQs = () => {
  UseScrollAnimation(); // ✅ just call it

  const [activeIndex, setActiveIndex] = useState(null);
  const faqRefs = useRef([]);

  const toggleFAQ = (index) => {
    const newIndex = activeIndex === index ? null : index;
    setActiveIndex(newIndex);

    // ⬇️ Auto scroll after opening
    setTimeout(() => {
      if (faqRefs.current[index]) {
        faqRefs.current[index].scrollIntoView({
          behavior: "smooth",
          block: "nearest",
        });
      }
    }, 200); // delay for animation sync
  };
  return (
    <>
      <div className="HomeParent">
        <div className="HomeBox ">
          <section className="Disclaimer_Section">
            <div className="Disclaimer_SectionBox">
              <div className="Disclaimer_Section_TitleHeadingContent">
                <p className="Disclaimer_Section_Title animate-top">FAQ's</p>
                <span className="Disclaimer_Section_Heading animate-top">
                  Questions, <br />
                  gently answered.
                </span>
                <p className="Disclaimer_Section_Content animate-top">
                  Curiosity is welcome here. If you don't see your question,
                  please reach out — I'm happy to talk it through.
                </p>
              </div>
            </div>
          </section>
          <section className="Disclaimer_Section00">
            <div className="Disclaimer_SectionParent01">
              {faqs.map((f, i) => (
                <div
                  className="Disclaimer_SectionBox02"
                  key={i}
                  ref={(el) => (faqRefs.current[i] = el)}
                >
                  <div
                    className="Disclaimer_Section_HeadingContent01"
                    onClick={() => toggleFAQ(i)}
                  >
                    <div className="Disclaimer_Section_Heading02 animate-top">
                      <span>{f.q}</span>

                      {/* ⬇️ Add rotation class */}
                      <span
                        className={`Disclaimer_Section_TopBottomArrow ${
                          activeIndex === i ? "rotate" : ""
                        }`}
                      >
                        {/* ▼ */}
                        <FaChevronDown />
                      </span>
                    </div>

                    {/* ⬇️ Always render for animation */}
                    <div
                      className={`faq-answer ${
                        activeIndex === i ? "open" : ""
                      }`}
                    >
                      <div className="Disclaimer_Section_Content03">{f.a}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </section>
          {/* <ThreeTestimonials /> */}

          {/* <AboutThePractitioner /> */}
        </div>
      </div>
    </>
  );
};

export default FAQs;
